import { createRouter, createWebHistory } from 'vue-router'
import { authApi } from '../api'

// 懒加载路由组件
const Dashboard = () => import('../views/Dashboard.vue')
const Players = () => import('../views/Players.vue')
const PlayerDetail = () => import('../views/PlayerDetail.vue')
const Sessions = () => import('../views/Sessions.vue')
const SessionDetail = () => import('../views/SessionDetail.vue')
const AddSession = () => import('../views/AddSession.vue')
const Stats = () => import('../views/Stats.vue')
const Login = () => import('../views/Login.vue')

const routes = [
  {
    path: '/',
    redirect: to => {
      // 如果已登录，重定向到dashboard
      const token = localStorage.getItem('token')
      if (token) {
        return '/dashboard'
      }
      // 未登录则重定向到登录页
      return '/login'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/players',
    name: 'Players',
    component: Players,
    meta: { requiresAuth: true }
  },
  {
    path: '/players/:id',
    name: 'PlayerDetail',
    component: PlayerDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/sessions',
    name: 'Sessions',
    component: Sessions,
    meta: { requiresAuth: true }
  },
  {
    path: '/sessions/:id',
    name: 'SessionDetail',
    component: SessionDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/add-session',
    name: 'AddSession',
    component: AddSession,
    meta: { requiresAuth: true }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats,
    meta: { requiresAuth: true }
  },
  {
    path: '/annual-ranking',
    name: 'AnnualRanking',
    component: () => import('../views/AnnualRanking.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/import',
    name: 'Import',
    component: () => import('../views/Import.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/gan-deng-yan',
    name: 'GanDengYan',
    component: () => import('../views/GanDengYan.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: () => import('../views/UserManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/menu-assignment',
    name: 'MenuAssignment',
    component: () => import('../views/MenuAssignment.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/online-import',
    name: 'OnlineImport',
    component: () => import('../views/OnlineImport.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mobile',
    component: () => import('@/views/mobile/MobileLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'active-sessions',
        name: 'MobileActiveSessions',
        component: () => import('@/views/mobile/ActiveSessions.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sessions/:id',
        name: 'MobileSessionDetail',
        component: () => import('@/views/mobile/SessionDetail.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'start-session',
        name: 'MobileStartSession',
        component: () => import('@/views/mobile/StartSession.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 如果是登录页面，直接通过
  if (to.path === '/login') {
    next()
    return
  }
  
  // 检查是否已认证
  const isAuthenticated = authApi.isAuthenticated()
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // 未认证且访问需要认证的页面，重定向到登录页
    next('/login')
  } else if (isAuthenticated && to.path === '/') {
    // 已认证且访问根路径，重定向到玩家页面
    next('/players')
  } else {
    // 其他情况正常通过
    next()
  }
})

export default router 